import '@vfde-brix/system-icon/dist/styles.css';
import { createSystemIconComponent } from '@vfde-brix/system-icon';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-system-icon', createSystemIconComponent, NO_PATTERN_BUSINESS_LOGIC);
